export default __webpack_public_path__ + "static/media/image8.35f49bf6.jpg";